import React from "react";
import { WhatsappIcon, PhoneDubaiIcon } from "../../../../app-constants";
import { Link } from "gatsby";

const Sidebtns = (props) => {
  const num_phone = props?.numbers;
  return (
    <div className="sidebtns-dubai">
      <div className="side-box">
        <ul>
          <li>
            <Link
              to={
                props?.numbers !== ""
                  ? `tel:${props?.numbers}`
                  : `tel:+971554573996`
              }
              aria-label="Phone Call"
              target="_blank"
              rel="noopener noreferrer"
            >
              {PhoneDubaiIcon}
            </Link>
          </li>
          <li>
            <Link
              to="https://wa.me/+971521565500"
              aria-label="Whatsapp Call"
              target="_blank"
              rel="noopener noreferrer"
            >
              {WhatsappIcon}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebtns;
